// extracted by mini-css-extract-plugin
export default {"HeaderCard":"CompanyProfileView_HeaderCard__Y5FBT","InnerDiv":"CompanyProfileView_InnerDiv__0sCpV"};